import React, {Component} from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import { Row, Col, Nav } from 'react-bootstrap';
import ThemeContext from "../../context/ThemeContext"
import { HeaderLink } from "../links/HeaderLink";
import { HeaderLink2 } from "../links/HeaderLink2";
// import AnchorLink from 'react-anchor-link-smooth-scroll';

const searchIndices = [
  { name: `Pages`, title: `Pages`, hitComp: `PageHit` },
  { name: `Posts`, title: `Blog Posts`, hitComp: `PostHit` },
]

class Header extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    scrollingUp: false,
    scrollingDown: false,
    floatHeader: false,
    headerOffset: 49,
  }

  componentDidMount() {
    this.prev = window.scrollY;
    window.addEventListener('scroll', e => this.handleNavigation(e));
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', e => this.handleNavigation(e));
  }

  handleNavigation = (e) => {
    const window = e.currentTarget;

    if (this.prev > window.scrollY) { //console.log("scrolling up");
        this.setState({scrollingUp: true, scrollingDown: false}, ()=> this.floatHeader("up"))
    } 
    else if (this.prev < window.scrollY) { //console.log("scrolling down");
        this.setState({scrollingUp: false, scrollingDown: true}, ()=> this.floatHeader("down"))
    }
    this.prev = window.scrollY;
  };

  floatHeader = (direction) => {
    if (direction === "up" && window.pageYOffset > this.state.headerOffset) {
      this.setState({floatHeader: true})
    }
    
    if ((direction === "up" && window.pageYOffset < this.state.headerOffset) || 
        (direction === "down" && window.pageYOffset > this.state.headerOffset)) {
      this.setState({floatHeader: false})
    }
  }

  render() {
    const { leftLogo, siteTitle } = this.props; 
    const { scrollingDown, scrollingUp, floatHeader, headerOffset } = this.state; 
    
    return (
      <ThemeContext.Consumer>
        {theme => (
          <header className={`header ${floatHeader && "fade-in-top float-header"} ${(scrollingDown) ? "float-header2 fade-out-top" : "header-offset"}`}
          
          >
              {/* <header> */}
                
                {/* <span>
                    <Search collapse indices={searchIndices} />
                  </span> */}
                
                <Row className="px-3 pr-4">
                  <Col md={3} className={`text-left tonye fade-in ${leftLogo ? "tonye-left": "tonye-top"}`}>
                    {/* <Link to="/"> 
                      <HeaderLink text="T" />
                    </Link> */}
                  </Col>
                  <Col md={8} className={`tonye nav-links text-right ${theme.menuExpanded ? "expanded-header-links" : ""}`}>
                    <ul>
                      <li>
                        <a href='#intro'><HeaderLink2 text="Intro" /></a>
                      </li>
                      <li>
                        <a href='#about'><HeaderLink2 text="About" /></a>
                      </li>
                      <li>
                        <a href='#portfolio'><HeaderLink2 text="Portfolio" /></a>
                      </li>
                      <li>
                        <a href='#apps'><HeaderLink2 text="Apps" /></a>
                      </li>
                      <li>
                        <a href='#music'><HeaderLink2 text="Music" /></a>
                      </li>
                      <li>
                        <a href='#contact'><HeaderLink2 text="Contact" /></a>
                      </li>
                    </ul>
                  </Col>
                </Row>
            </header>
        )}
      </ThemeContext.Consumer>
    )
  }
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: `Tonye's Blog`,
}

export default Header;
